import { useState } from "react";
import { API } from "./api";

export function useAsistenteChat(onDone) {
  const [sid, setSid] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [busy, setBusy] = useState(false);

  const send = async (message) => {
    if (!message || busy) return;
    setBusy(true);
    setMsgs((m) => [...m, { role: "user", content: message }, { role: "assistant", content: "" }]);
    const append = (s) => setMsgs((m) => { const c = [...m]; c[c.length - 1] = { ...c[c.length - 1], content: c[c.length - 1].content + s }; return c; });
    try {
      const res = await fetch(`${API}/asistente/chat`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message, session_id: sid }),
      });
      if (!res.ok || !res.body) throw new Error();
      const reader = res.body.getReader();
      const dec = new TextDecoder();
      let buf = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += dec.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          const line = p.replace(/^data: /, "");
          if (!line || line === "[DONE]") continue;
          const ev = JSON.parse(line);
          if (ev.session_id) setSid(ev.session_id);
          if (ev.delta) append(ev.delta);
          if (ev.error) append(ev.error);
        }
      }
      onDone?.();
    } catch {
      append("No he podido responder ahora, inténtalo de nuevo.");
    } finally {
      setBusy(false);
    }
  };

  const reset = () => { setSid(null); setMsgs([]); };
  return { sid, setSid, msgs, setMsgs, busy, send, reset };
}
